import './menu.css';

import React, { Component } from 'react';
import { Link, Redirect } from 'react-router';
import Icon from '../components/Icon';
import lang, { selectedLocalization } from '../services/lang';
import { menuItems } from '../services/content';
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';
import { isApp } from '../services/config';

export default class Menu extends Component {
  componentWillMount() {
    console.log(this.props);
    if(isApp) {
      this.props.router.push('/');
      return;
    }
  }

  componentDidMount() {
    beep();
    trackView("Main Menu");
  }
  
  renderMenuItem = item => {
    const {
      href,
      icon,
    } = item;
    
    const title = item[`title_${selectedLocalization}`] || item.title;
    const text = item[`text_${selectedLocalization}`] || item.text;
    
    return (
      <Link to={`/${href}`} className="menu-item" key={href}>
        <Icon name={icon} className="menu-item-icon"/>
        <div className="menu-item-title">{title}</div>
        <div 
          className="menu-item-text" 
          dangerouslySetInnerHTML={{__html:text}}/>
      </Link>
    );
  }
  
  render() {
    if(isApp) {
      return null;
    }

    return (
      <div className="menu">
        <h1>{lang('menu-title')}</h1>
        
        <div className="menu-content">
        
          <div className="menu-items">
            {menuItems.map(this.renderMenuItem)}
          </div>
          
          <Link to="/language" className="menu-button-small">
            <div>Change Language</div>
            <div>Cambiar el idioma</div>
            <div>Изменить язык</div>
            <div>改變语言</div>
          </Link>
          
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Menu.js